// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2mMzV","cell":"ColumnAccessor_cell__2QnM1","firstCellAccent":"ColumnAccessor_firstCellAccent__3Qe1C"};